import type { ComponentProps } from 'react';
import { BillLineIcon } from 'ui';
import type { PostTodo } from '../../../../types';
import { BaseTodoWidgetItem } from '../base-todo-widget-item';

type P = {
  className?: string;
  todo: PostTodo;
  type?: ComponentProps<typeof BaseTodoWidgetItem>['type'];
};

const PostTodoWidgetItem = ({ className, todo, type }: P) => (
  <BaseTodoWidgetItem
    additionalDescription={todo.post.textContent}
    className={className}
    description={todo.post.title}
    icon={<BillLineIcon />}
    path={todo.path}
    timeConfig={{ options: { display: 'time', mode: 'by' }, time: todo.endTime }}
    title="Read post"
    type={type}
  />
);

export default PostTodoWidgetItem;
